<ds-form-field
  [id]="controlId()"
  [label]="label()"
  [required]="required()"
  [isInvalid]="controlInvalid()"
  [hintAfter]="hintAfter()"
  [errors]="control.errors"
  [readonly]="readonly()"
>
  <div class="input-wrapper">
    <input
      [dsAriaLabelledBy]="label() ? null : controlId()"
      class="form-control"
      [class.invalid]="controlInvalid()"
      [formControl]="control"
      [id]="controlId()"
      [type]="inputType()"
      [placeholder]="placeholder()"
      [attr.min]="min()"
      [attr.max]="max()"
      [attr.minlength]="minlength()"
      [attr.maxlength]="maxlength()"
      [attr.pattern]="pattern()"
      [attr.disabled]="isDisabled() ? true : null"
      [attr.readonly]="readonly() ? true : null"
      [attr.required]="required() ? true : null"
      [attr.autocapitalize]="autocapitalize()"
      [attr.autocomplete]="autocompleteValue()"
      [attr.aria-describedby]="describedByIds()"
      [inputMode]="inputmode()"
      (input)="setValue($event)"
    />

    @if (icon()) {
      <ds-icon class="icon" [set]="iconSet()" [name]="icon()!" />
    }

    @if (type() === "password" && passwordToggle()) {
      <button
        type="button"
        class="password-toggle-button"
        (click)="togglePasswordVisibility()"
        [attr.aria-label]="passwordVisible() ? 'Verberg wachtwoord' : 'Toon wachtwoord'"
        [attr.aria-pressed]="passwordVisible()"
      >
        @if (passwordVisible()) {
          <ds-icon class="password-toggle-icon" set="rijks" name="eye" />
        } @else {
          <ds-icon class="password-toggle-icon" set="rijks" name="eye-off" />
        }
      </button>
    }
  </div>
</ds-form-field>
